<template>
    <section class="dp-layout">
        <section class="dp-left">
            <DepartmentPane directory-scope="teaching" @tree-node-click="treeNodeClick"></DepartmentPane>
        </section>

        <section class="dp-right">
            <div class="toolbar-filter-bar">
            <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
                <el-form :inline="true" :model="filters" class="toolbar-filter-form">
                    <div class="toolbar-filter-fields">
                    <el-form-item label="学期">
                        <el-select v-model="selectedSemesterId" placeholder="学期" @change="handleSemesterChange"
                            class="toolbar-field-w-lg">
                            <el-option v-for="item in semesterList" :key="item.Id" :label="item.SemesterName"
                                :value="item.Id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="周次">
                        <el-select v-model="filters.week" placeholder="周次" @change="handleWeekChange"
                            class="toolbar-field-w-week" clearable>
                            <el-option v-for="item in weeksOptions" :key="item.value" :label="item.label"
                                :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="评价类别">
                        <el-cascader v-model="filters.evaluationId" :options="evaluationOptions" placeholder="评价类别"
                            clearable class="toolbar-field-w-md"></el-cascader>
                    </el-form-item>
                    <el-form-item label="检查人">
                        <el-input v-model="filters.createBy" placeholder="检查人" class="toolbar-field-w-sm"
                            clearable></el-input>
                    </el-form-item>
                    <el-form-item label="学生姓名">
                        <el-input v-model="filters.studentName" placeholder="学生姓名" class="toolbar-field-w-sm"
                            clearable></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-select v-model="filters.changeType" placeholder="类型" clearable class="toolbar-field-w-sm"
                            @change="handleQuery">
                            <el-option label="全部" value=""></el-option>
                            <el-option label="加分" value="Addition"></el-option>
                            <el-option label="扣分" value="Deduction"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" size="small" icon="el-icon-search" @click="handleQuery">查询</el-button>
                    </el-form-item>
                    </div>
                    <div class="toolbar-filter-actions">
                        <el-button v-for="item in buttonList.filter(b => b.Func === 'exportExcel')" :key="item.id"
                            size="small" type="warning" icon="el-icon-download" @click="exportExcel">{{ item.name }}</el-button>
                        <el-button v-for="item in buttonList.filter(b => b.Func === 'handleDel')" :key="item.id"
                            size="small" type="danger" icon="el-icon-delete" @click="handleDel">{{ item.name }}</el-button>
                    </div>
                </el-form>
            </el-col>
            </div>

            <!-- 评分记录表 -->
                        <el-table :data="recordsList" v-loading="recordsLoading" style="width: 100%;"
                @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column prop="DepartmentName" label="班级" width=""></el-table-column>
                <el-table-column prop="StudentName" label="学生姓名" show-overflow-tooltip
                    min-width="120"></el-table-column>
                <el-table-column label="是否小组" width="">
                    <template slot-scope="scope">
                        <span
                            :style="{ color: (scope.row.GroupId && scope.row.GroupId != '0') ? '#67C23A' : '#909399' }">
                            {{ (scope.row.GroupId && scope.row.GroupId != '0') ? '是' : '否' }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="GroupName" label="小组名称" show-overflow-tooltip width=""></el-table-column>
                <el-table-column prop="DimensionName" label="评分类别" width=""></el-table-column>
                <el-table-column label="子类别" min-width="120" class-name="wrap-cell">
                    <template slot-scope="scope">
                        <div class="single-line-tags line-clamp-3">
                            <el-tag v-for="(p, idx) in getParentListSafe(scope.row)" :key="idx"
                                :type="itemKindTagType(p.itemKind)" size="small">{{ p.name }}</el-tag>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="SelectedItemsSummary" label="摘要" min-width="180">
                    <template slot-scope="scope">
                        <div class="single-line-tags wrap-cell-2">
                            <el-tag v-for="(s, i) in parseSelectedItemsSafe(scope.row)" :key="i"
                                :type="itemKindTagType(s.itemKind)" size="small">
                                {{ s.text }}
                            </el-tag>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="TotalScore" label="总分" width="">
                    <template slot-scope="scope">
                        <span :class="scoreClass(scope.row.TotalScore)">{{ formatDecimal(scope.row.TotalScore) }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="CreateTime" label="点评时间" width="">
                    <template slot-scope="scope">{{ formatCreateTime(scope.row.CreateTime) }}</template>
                </el-table-column>
                <el-table-column prop="CreateBy" label="点评人" width=""></el-table-column>
                <el-table-column label="操作" width="">
                    <template slot-scope="scope">
                        <el-button type="text" @click="openRecordDetail(scope.row)">查看</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <div style="text-align: right; margin-top: 12px;">
                <el-pagination layout="total, prev, pager, next, jumper" :current-page="recordsPage"
                    :page-size="recordsPageSize" :total="recordsTotal" @current-change="loadRecords"></el-pagination>
            </div>

            <!-- 点评详情对话框 -->
            <el-dialog title="点评详情" :visible.sync="detailDialogVisible" :close-on-click-modal="false" width="60%">
                <div v-if="!recordDetail" style="text-align:center; padding:20px">无详情</div>
                <div v-else class="record-info">
                    <p class="muted">学生：<el-tooltip :content="recordDetail.StudentName" placement="top"><strong
                                style="display:inline-block;max-width:300px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;vertical-align:bottom;">{{
                                    recordDetail.StudentName }}</strong></el-tooltip>&nbsp;&nbsp; 班级：<strong>{{
                                    recordDetail.DepartmentName }}</strong>&nbsp;&nbsp; 点评时间：<strong>{{
                                formatCreateTime(recordDetail.CreateTime) }}</strong>&nbsp;&nbsp; 总分： <span
                            :class="scoreClass(recordDetail.TotalScore)">{{ formatDecimal(recordDetail.TotalScore)
                            }}</span></p>
                    <p class="summary">摘要：<span class="record-summary">{{ recordDetail.SelectedItemsSummary }}</span>
                    </p>
                    <el-table :data="recordDetail.Items || []" style="width:100%; margin-top:10px" border>
                        <el-table-column label="类别" width="150">
                            <template slot-scope="scope">{{ (recordDetail.DimensionName || '') +
                                (scope.row.ParentDimensionName ? (' / ' + scope.row.ParentDimensionName) : '')
                            }}</template>
                        </el-table-column>
                        <el-table-column label="评价项" width="150" show-overflow-tooltip>
                            <template slot-scope="scope">{{ formatItemName(scope.row) }}</template>
                        </el-table-column>
                        <el-table-column prop="ItemKind" label="类型" width="">
                            <template slot-scope="scope">{{ scope.row.ItemKind === 'Praise' ? '表扬' : (scope.row.ItemKind
                                === 'Improvement' ? '待改进' : scope.row.ItemKind) }}</template>
                        </el-table-column>
                        <el-table-column prop="UnitScore" label="单项分" width="">
                            <template slot-scope="scope"><span :class="scoreClass(scope.row.UnitScore)">{{
                                formatDecimal(scope.row.UnitScore) }}</span></template>
                        </el-table-column>
                        <el-table-column prop="Quantity" label="数量" width=""></el-table-column>
                        <el-table-column prop="Score" label="分值" width="">
                            <template slot-scope="scope"><span :class="scoreClass(scope.row.Score)">{{
                                formatDecimal(scope.row.Score) }}</span></template>
                        </el-table-column>
                        <el-table-column prop="Comment" label="备注"></el-table-column>
                        <el-table-column prop="MediaFiles" label="媒体文件" width="">
                            <template slot-scope="scope">
                                <oss-media-thumbs v-if="getImageList(scope.row).length > 0"
                                    :media="scope.row.MediaFiles" :max="3" />
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="detailDialogVisible = false">关闭</el-button>
                </div>
            </el-dialog>

        </section>
    </section>
</template>

<script>
import util from "../../../util/date";
import { getStudentScoreRecords, getEvaluationDimensionSecondLevel, exportStudentScoreRecords, batchDeleteStudentScoreRecords } from '../../api/modules/moral-education';
import { BaseApiUrl } from '../../api/base';
import { getSemesterWeeksByClassId, getSemesterList } from '../../api/modules/misc';
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import DepartmentPane from '../../components/DepartmentPane';

export default {
    components: { Toolbar, DepartmentPane },
    data() {
        return {
            semesterList: [],
            selectedSemesterId: null,
            weeksData: [],
            weeksOptions: [],
            evaluationOptions: [],
            buttonList: [],
            recordsLoading: false,
            DepartmentId: 0,
            filters: {
                week: '',
                evaluationId: [],
                createBy: '',
                studentName: '',
                changeType: ''
            },
            recordsList: [],
            recordsPage: 1,
            recordsPageSize: 10,
            recordsTotal: 0,
            multipleSelection: [],
            BaseApiUrl: BaseApiUrl,
            detailDialogVisible: false,
            recordDetail: null
        };
    },
    methods: {
        scoreClass(val) {
            if (val === null || val === undefined || val === '') return '';
            const n = Number(val);
            if (isNaN(n)) return '';
            if (n > 0) return 'add-value';
            if (n < 0) return 'deduct-value';
            return '';
        },
        getImageList(row) {
            return this.showImage(row && row.MediaFiles);
        },
        parseSelectedItemsSafe(row) {
            const src = row.SelectedItemsSummary;
            if (!src) return [];
            const result = [];
            const parts = String(src).split(/[,，]/).map(s => s.trim()).filter(Boolean);
            parts.forEach(part => {
                const fullText = part;
                // remove common trailing multipliers like x1, ×1, *1, (1), 1次 等
                let normalized = fullText.replace(/\s*(?:x|×|\*)\s*\d+\s*$/i, '').replace(/\s*\(\s*\d+\s*\)\s*$/, '').replace(/\s*\d+\s*(?:次|次?)\s*$/i, '').trim();
                // also remove trailing pure digits
                normalized = normalized.replace(/\s*\d+\s*$/, '').trim();

                let parentName = '';
                let itemKind = '';
                if (row.Items && Array.isArray(row.Items)) {
                    const found = row.Items.find(it => {
                        const display = this.formatItemName(it);
                        return display === normalized || display === fullText
                            || it.ItemName === normalized || it.ItemName === fullText
                            || (it.Comment || '').trim() === normalized;
                    });
                    if (found) {
                        parentName = found.ParentDimensionName || found.DimensionName || '';
                        itemKind = found.ItemKind || '';
                    }
                }

                // 直接显示原始文本，不按字数截断
                result.push({ text: fullText, fullText: fullText, parent: parentName, itemKind });
            });
            return result;
        },
        getParentNames(record) {
            if (!record || !record.Items || !Array.isArray(record.Items)) return '';
            const set = new Set();
            record.Items.forEach(it => {
                if (it && it.ParentDimensionName) set.add(String(it.ParentDimensionName).trim());
            });
            return Array.from(set).filter(Boolean).join(', ');
        },
        getParentList(record) {
            if (!record || !record.Items || !Array.isArray(record.Items)) return [];
            const map = new Map();
            record.Items.forEach(it => {
                if (!it || !it.ParentDimensionName) return;
                const name = String(it.ParentDimensionName).trim();
                if (!name) return;
                const kind = String(it.ItemKind || '').trim();
                if (!map.has(name)) {
                    map.set(name, kind);
                } else if (kind && map.get(name) && map.get(name) !== kind) {
                    map.set(name, 'Mixed');
                } else if (kind && !map.get(name)) {
                    map.set(name, kind);
                }
            });
            return Array.from(map.entries()).map(([name, itemKind]) => ({ name, itemKind }));
        },
        getParentListSafe(record) {
            try {
                const l = this.getParentList(record);
                return Array.isArray(l) ? l : [];
            } catch (e) {
                return [];
            }
        },
        itemKindTagType(itemKind) {
            if (itemKind === 'Praise') return 'success';
            if (itemKind === 'Improvement') return 'danger';
            if (itemKind === 'Mixed') return 'warning';
            return 'info';
        },
        openRecordDetail(row) {
            if (!row) return;
            this.recordDetail = row;
            this.detailDialogVisible = true;
        },
        /**
         * 评价项展示名：模板项用 ItemName；图文/自定义点评 ItemName 为空时用备注，再兜底「自定义」。
         */
        formatItemName(item) {
            if (!item) return '';
            const name = (item.ItemName || '').trim();
            if (name) return name;
            const comment = (item.Comment || '').trim();
            if (comment) return comment;
            if (item.IsCustom) return '自定义';
            return '';
        },
        formatDecimal(val) {
            if (val === null || val === undefined || val === '') return '';
            const n = Number(val);
            if (isNaN(n)) return val;
            return n.toFixed(2);
        },
        formatCreateTime(val) {
            return !val || val === '' ? '' : util.formatDate.format(new Date(val), 'yyyy-MM-dd hh:mm:ss')
        },
        treeNodeClick(data) {
            this.DepartmentId = data.value;
            // 切换学校时清空周次等筛选，避免沿用上一学校的数据
            this.filters.week = '';
            this.filters.evaluationId = [];
            this.weeksData = [];
            this.weeksOptions = [];
            this.recordsList = [];
            this.recordsTotal = 0;
            this.recordsPage = 1;
            // 加载评价维度用于级联选择
            this.loadEvaluationOptions(this.DepartmentId);
            // 加载学期
            this.loadSemesters().then(() => {
                // 加载周次
                this.loadWeeks(this.DepartmentId, this.selectedSemesterId).then(() => {
                    this.handleQuery();
                });
            });
        },

        handleSelectionChange(val) {
            this.multipleSelection = val;
        },

        // 批量删除
        handleDel() {
            if (!this.multipleSelection || this.multipleSelection.length === 0) {
                this.$message.warning('请选择要删除的记录');
                return;
            }

            this.$confirm(`确认删除选中的 ${this.multipleSelection.length} 条记录吗？(如果是小组评价将同步删除整组记录)`, '提示', {
                type: 'warning'
            }).then(() => {
                const ids = this.multipleSelection.map(x => x.RecordId);
                this.recordsLoading = true;
                batchDeleteStudentScoreRecords(ids).then(res => {
                    this.recordsLoading = false;
                    if (res && res.data && res.data.success) {
                        this.$message.success('删除成功');
                        this.handleQuery();
                    } else {
                        this.$message.error((res && res.data && res.data.msg) || '删除失败');
                    }
                }).catch(err => {
                    this.recordsLoading = false;
                    this.$message.error('删除请求出错');
                    console.error(err);
                });
            }).catch(() => { });
        },

        // 加载学期列表
        loadSemesters() {
            if (!this.DepartmentId) return Promise.resolve();
            return getSemesterList({ departmentId: this.DepartmentId }).then(res => {
                if (res.success && res.response && res.response.length > 0) {
                    this.semesterList = res.response;
                    const current = this.semesterList.find(s => s.IsCurrent === 1) || this.semesterList[0];
                    if (current) this.selectedSemesterId = current.Id;
                } else {
                    this.semesterList = [];
                    this.selectedSemesterId = null;
                }
            });
        },

        handleSemesterChange(val) {
            this.filters.week = '';
            this.loadWeeks(this.DepartmentId, val).then(() => {
                this.handleQuery();
            });
        },

        handleWeekChange(val) {
            this.handleQuery();
        },

        // 加载评价维度级联选项
        loadEvaluationOptions(departmentId) {
            if (!departmentId) return;
            getEvaluationDimensionSecondLevel({ departmentId: departmentId }).then(res => {
                if (res && res.data && res.data.success) {
                    const list = res.data.response || [];
                    this.evaluationOptions = (list || []).map(parent => ({
                        label: parent.Name || '',
                        value: parent.Id,
                        children: (parent.Children || []).map(child => ({ label: child.Name || '', value: child.Id }))
                    }));
                } else {
                    this.evaluationOptions = [];
                }
            }).catch(() => {
                this.evaluationOptions = [];
            });
        },
        async exportExcel() {
            try {
                const deptId = this.DepartmentId || 0;
                let from = null;
                let to = null;

                if (this.filters.week && this.weeksData.length) {
                    const wobj = this.weeksData.find(x => x.WeekNumber === this.filters.week);
                    if (wobj && wobj.Days.length) {
                        from = String(wobj.Days[0].Date || '').split(' ')[0];
                        to = String(wobj.Days[wobj.Days.length - 1].Date || '').split(' ')[0];
                    }
                }

                const params = {
                    departmentId: deptId,
                    studentName: this.filters.studentName || '',
                    createBy: this.filters.createBy || '',
                    from: from,
                    to: to,
                    changeType: this.filters.changeType || '',
                };

                const ev = this.filters.evaluationId;
                if (ev && ev.length) {
                    params.evaluationId = ev[ev.length - 1];
                }

                const response = await exportStudentScoreRecords(params);
                if (!response.data) {
                    this.$message.error("导出数据为空");
                    return;
                }

                const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                const url = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                const startDateStr = from ? from.replace(/-/g, '') : '00000000';
                const endDateStr = to ? to.replace(/-/g, '') : '99999999';
                const weekStr = this.filters.week ? `第${this.filters.week}周` : '';
                const kindStr = this.filters.changeType === 'Addition'
                    ? '加分'
                    : (this.filters.changeType === 'Deduction' ? '扣分' : '');
                link.setAttribute('download', `${weekStr}学生评价${kindStr}记录_${startDateStr}_${endDateStr}.xlsx`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(url);
            } catch (error) {
                this.$message.error('导出出错');
                console.error('下载失败:', error);
            }
        },

        handleQuery() {
            const deptId = this.DepartmentId || 0;
            let from = null;
            let to = null;

            if (this.filters.week && this.weeksData.length) {
                const wobj = this.weeksData.find(x => x.WeekNumber === this.filters.week);
                if (wobj && wobj.Days.length) {
                    from = String(wobj.Days[0].Date || '').split(' ')[0];
                    to = String(wobj.Days[wobj.Days.length - 1].Date || '').split(' ')[0];
                }
            }

            this.loadRecords(1, deptId, from, to, this.filters.studentName, this.filters.createBy);
        },
        loadWeeks(departmentId, semesterId = null) {
            if (!departmentId) {
                this.weeksData = [];
                this.weeksOptions = [];
                this.filters.week = '';
                return Promise.resolve();
            }
            this.weeksOptions = [];
            this.filters.week = '';
            let params = { departmentId: departmentId };
            if (semesterId) params.semesterId = semesterId;

            return getSemesterWeeksByClassId(params).then(res => {
                if (res && res.data && res.data.success) {
                    const resp = res.data.response || [];
                    this.weeksData = resp;
                    const opts = resp.map(w => {
                        let firstDate = '';
                        let lastDate = '';
                        if (Array.isArray(w.Days) && w.Days.length) {
                            firstDate = String(w.Days[0].Date || '').split(' ')[0];
                            lastDate = String(w.Days[w.Days.length - 1].Date || '').split(' ')[0];
                        }
                        const label = (firstDate && lastDate) ? `第${w.WeekNumber}周 (${firstDate} ~ ${lastDate})` : `第${w.WeekNumber}周`;
                        return { label, value: w.WeekNumber };
                    });
                    this.weeksOptions = opts;

                    // 选择默认周
                    const now = new Date();
                    const todayStr = util.formatDate.format(now, 'yyyy-MM-dd');

                    let defaultWeekNum = null;
                    for (const w of resp) {
                        if (Array.isArray(w.Days)) {
                            if (w.Days.find(day => String(day.Date || '').split(' ')[0] === todayStr)) {
                                defaultWeekNum = w.WeekNumber;
                                break;
                            }
                        }
                    }

                    if (defaultWeekNum === null && opts.length > 0) defaultWeekNum = opts[0].value;
                    if (defaultWeekNum !== null) {
                        this.filters.week = defaultWeekNum;
                    } else {
                        this.filters.week = '';
                    }
                } else {
                    this.weeksData = [];
                    this.weeksOptions = [];
                    this.filters.week = '';
                    this.$message.warning('获取周次失败');
                }
            }).catch(() => {
                this.weeksData = [];
                this.weeksOptions = [];
                this.filters.week = '';
                this.$message.error('获取周次出错');
            });
        },
        loadRecords(page = 1, departmentId, from, to, studentName, createBy) {
            const dept = departmentId || this.DepartmentId || 0;
            const s = studentName || this.filters.studentName || '';
            const c = createBy || this.filters.createBy || '';
            let f = from;
            let t = to;

            if (!f || !t) {
                if (this.filters.week && this.weeksData.length) {
                    const wobj = this.weeksData.find(x => x.WeekNumber === this.filters.week);
                    if (wobj && wobj.Days.length) {
                        f = String(wobj.Days[0].Date || '').split(' ')[0];
                        t = String(wobj.Days[wobj.Days.length - 1].Date || '').split(' ')[0];
                    }
                }
            }

            if (!dept) {
                this.$message.warning('请选择部门');
            }

            this.recordsLoading = true;
            const params = {
                departmentId: dept || 0,
                studentName: s,
                createBy: c,
                from: f,
                to: t,
                page: page,
                pageSize: this.recordsPageSize || 10,
                changeType: this.filters.changeType || '',
            };

            const ev = this.filters.evaluationId;
            if (ev && ev.length) {
                params.evaluationId = ev[ev.length - 1];
            }

            getStudentScoreRecords(params).then(async (res) => {
                if (res && res.data && res.data.success) {
                    const resp = res.data.response || {};
                    // 支持后端返回分页结构 resp.data
                    if (Array.isArray(resp.data)) {
                        const rows = resp.data;
                        await this.prefetchListOssMedia(rows, 'MediaFiles');
                        this.recordsList = rows;
                        this.recordsTotal = resp.dataCount || resp.dataCount || 0;
                        this.recordsPage = resp.page || page;
                        this.recordsPageSize = resp.PageSize || this.recordsPageSize;
                    } else if (Array.isArray(res.data.response)) {
                        this.recordsList = res.data.response;
                        this.recordsTotal = res.data.response.length;
                        this.recordsPage = page;
                    } else if (Array.isArray(res.data)) {
                        this.recordsList = res.data;
                        this.recordsTotal = res.data.length;
                        this.recordsPage = page;
                    } else {
                        this.recordsList = [];
                        this.recordsTotal = 0;
                    }
                } else {
                    this.$message.error(res && res.data ? res.data.msg : '获取学生点评记录失败');
                }
            }).catch(() => {
                this.$message.error('获取学生点评记录出错');
            }).finally(() => {
                this.recordsLoading = false;
            });
        }
    },
    mounted() {
        let routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : [];
        this.buttonList = getButtonList(this.$route.path, routers);
    }
};
</script>

<style scoped>
.add-value {
    color: #67C23A;
}

.deduct-value {
    color: #F56C6C;
}

.record-info {
    margin-bottom: 12px;
}

.record-info .muted {
    color: #606266;
    margin: 0 0 6px 0;
}

.record-info .summary {
    margin: 0;
    color: #606266;
}

.record-score {
    font-weight: 700;
}

.record-summary {
    color: #909399;
}

.single-line-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    align-items: center;
    padding: 2px 0;
}

.single-line-tags .el-tag {
    display: inline-block;
    margin: 0;
    white-space: normal !important;
    /* 允许内部换行 */
    height: auto !important;
    /* 高度自适应 */
    line-height: 18px !important;
    padding: 2px 8px !important;
    max-width: 300px;
    /* 限制单个标签最大宽度 */
}

/* 强制覆盖表格单元格的溢出隐藏限制 */
::v-deep .wrap-cell .cell {
    white-space: normal !important;
    word-break: break-all !important;
    line-height: 22px;
}

/* 子类别：允许换行 */
.line-clamp-3 {
    display: flex !important;
    flex-wrap: wrap !important;
    gap: 4px !important;
}

/* 摘要列：允许换行 */
.wrap-cell-2 {
    display: flex !important;
    flex-wrap: wrap !important;
    gap: 4px !important;
}
</style>
